//TODO: REMOVE
export const URL_FLOOD_JSON = 'https://raw.githubusercontent.com/bertranddelvaux/arc_flood_data_tmp/main/jsons/';
export const URL_FLOOD_RISK_PARAMETERS = 'https://raw.githubusercontent.com/bertranddelvaux/arc_flood_data_tmp/main/risk_parameters/';
//TODO: REMOVE

export const URL_ROOT =  'https://raw.githubusercontent.com/bertranddelvaux/arc-flood-backend/main/';
export const URL_ROOT_FLE = 'https://ff.arc.int/'; //data/
//export const URL_ROOT_FLE = 'https://raw.githubusercontent.com/bertranddelvaux/arc_flood_data_tmp/main/';

export const COUNTRIES = ['civ', 'mdg', 'moz', 'mwi', 'tgo', 'gha']; //TODO: add 'gha' when JBA has sorted the issue...

// order in which the flood data of the countries is downloaded (smallest files first), and how many at a time
export const COUNTRIES_LOAD_ORDER = ['tgo', 'mwi', 'civ', 'mdg', 'moz', 'gha'];
export const COUNTRIES_LOAD_CONCURRENCY = 2;

export const COUNTRIES_STOCHASTIC = ['civ', 'mdg', 'moz', 'mwi', 'tgo', 'gha'];

export const KNTS2KMH = 1.852

// wind speed categories (in knots)
export const CAT_KNOTS = [0,28,34,48,64,90,115];

export const WIND_TEXT = ['< 50 km/h', '51-62 km/h', '63-88 km/h', '89-117 km/h', '118-165 km/h', '166-212 km/h', '> 212 km/h']

// wind category colors
export const WIND_COLORS = [
    '#6533ff',
    '#0099fe',
    '#01ff66',
    '#ffcc01',
    '#ff9900',
    '#f00000',
    '#b3160c',
];

// wind gradient colors
export const WIND_GRADIENT_COLORS = [
    {value: 28 , color: 'rgba(1,196,255,0.5)'},
    {value: 34 , color: '#fdfdfd'},
    {value: 64 , color: '#ff2400'},
    {value: 115 , color: '#b3160c'}
]

// surge gradient colors
export const SURGE_GRADIENT_COLORS = [
    {value: 0 , color: 'rgba(1,43,255,0.5)'},
    {value: 1 , color: '#b119ee'},
    {value: 7 , color: '#fc02ac'}
]

// excess rain gradient colors
/*export const EXCESS_RAIN_GRADIENT_COLORS = [
    {value: 3, class: 1 , color: '#aaffee'},
    {value: 7.5, class: 2 , color: '#aa007f'},
    {value: 17.5, class: 3 , color: '#aa00bb'},
    {value: 37.5, class: 4 , color: '#aa0099'},
    {value: 75, class: 5 , color: '#aa0033'},
    {value: 150, class: 6 , color: '#aacc00'},
    {value: 300, class: 7 , color: '#aaaa00'}
]*/

export const FLOOD_DEPTH_GRADIENT_COLORS = [
    { value: 1, color: '#440154' },
    { value: 19, color: '#482878' },
    { value: 37, color: '#3e4989' },
    { value: 55, color: '#31688e' },
    { value: 73, color: '#26828e' },
    { value: 91, color: '#1f9e89' },
    { value: 109, color: '#35b779' },
    { value: 127, color: '#6ece58' },
    { value: 145, color: '#b5de2b' },
    { value: 163, color: '#fde725' },
    { value: 181, color: '#fee740' },
    { value: 199, color: '#f9d057' },
    { value: 211, color: '#f08e48' },
];


export const EXCESS_RAIN_GRADIENT_COLORS = [
    {value: 250, color: '#647ce3'},
    {value: 500, color: '#63e3c8'},
    {value: 3000, color: '#b3e363'},
    {value: 4000, color: '#e2e263'},
    {value: 5000, color: '#c78542'},
    {value: 6000, color: '#a13231'},
    {value: 7000, color: '#f91314'},
    {value: 10000, color: '#feafb9'},
    {value: 15000, color: '#ef01c6'},
    {value: 25000, color: '#a8008b'},
]

export const POP_EXPOSED_BAND_1_GRADIENT_COLORS = [
    {value: 25, color: '#647ce3'},
    {value: 51, color: '#63e3c8'},
    {value: 102, color: '#b3e363'},
    {value: 152, color: '#e2e263'},
    {value: 203, color: '#c78542'},
    {value: 254, color: '#a13231'},
    {value: 305, color: '#f91314'},
    {value: 406, color: '#feafb9'},
    {value: 508, color: '#ef01c6'},
    {value: 610, color: '#a8008b'},
]

export const LANDSLIDE_GRADIENT_COLORS = [
    {value: 1, color: '#ffcc5f'},
    {value: 2, color: '#f03b20'},
]

// population gradient colors
export const POPULATION_GRADIENT_COLORS = [
    {value: 10000 , color: '#7f47c4'},
    {value: 500000 , color: '#fff100'},
    {value: 2500000 , color: '#e56210'}
]

// value gradient colors
export const VALUE_GRADIENT_COLORS = [
    {value: 500000 , color: '#01c4ff'}, // 396433
    {value: 250000000 , color: '#fff100'}, // 250000000
    {value: 1000000000 , color: '#ff2400'} // 1295198912
]

// stochastic heatmap gradient colors
export const HEATMAP_GRADIENT_COLORS = [
    {value: 0 , color: 'rgba(33,102,172,0)'},
    {value: 0.2 , color: 'rgba(103,169,207,0.3)'},
    {value: 0.4 , color: 'rgba(209,229,240,0.4)'},
    {value: 0.6 , color: 'rgba(253,219,199,0.5)'},
    {value: 0.8 , color: 'rgba(239,138,98,0.6)'},
    {value: 1 , color: 'rgba(178,24,43,0.7)'},

]

// stochastic trajectories gradient colors
export const TRAJECTORIES_GRADIENT_COLORS = [
    {value: 25 , color: '#f6ea08'},
    {value: 70 , color: '#f69708'},
    {value: 100 , color: '#f64f08'},
]

// former wind category colors
/*export const WIND_COLORS = [
    '#babe03',
    '#eba63f',
    '#d94d09',
    '#bc1b1b',
    '#a01616'
];*/

// cyclone categories
export const WIND_CATEGORIES = [
    'Disturbance',
    'Tropical depression',
    'Moderate tropical storm',
    'Severe tropical storm',
    'Tropical cyclone',
    'Intense tropical cyclone',
    'Very intense tropical cyclone',
];

// cyclone categories (with short name)
export const wind_categories = [
    {name: 'Disturbance', short: 'B'},
    {name: 'Tropical depression', short: 'D'},
    {name: 'Moderate tropical storm', short: 'S'},
    {name: 'Severe tropical storm', short: 'SS'},
    {name: 'Tropical cyclone', short: 'C'},
    {name: 'Intense tropical cyclone', short: 'IC'},
    {name: 'Very intense tropical cyclone', short: 'VC'},
];

// cyclone icons
export const ICONS = [
    {id: 'cyclone_1_past', url: URL_ROOT + 'public/img/tc_icon_1_past_256.png'},
    {id: 'cyclone_1_fcst', url: URL_ROOT + 'public/img/tc_icon_1_fcst_256.png'},
    {id: 'cyclone_2_past', url: URL_ROOT + 'public/img/tc_icon_2_past_256.png'},
    {id: 'cyclone_2_fcst', url: URL_ROOT + 'public/img/tc_icon_2_fcst_256.png'},
    {id: 'cyclone_3_past', url: URL_ROOT + 'public/img/tc_icon_3_past_256.png'},
    {id: 'cyclone_3_fcst', url: URL_ROOT + 'public/img/tc_icon_3_fcst_256.png'},
    {id: 'cyclone_4_past', url: URL_ROOT + 'public/img/tc_icon_4_past_256.png'},
    {id: 'cyclone_4_fcst', url: URL_ROOT + 'public/img/tc_icon_4_fcst_256.png'},
    {id: 'cyclone_5_past', url: URL_ROOT + 'public/img/tc_icon_5_past_256.png'},
    {id: 'cyclone_5_fcst', url: URL_ROOT + 'public/img/tc_icon_5_fcst_256.png'},
];

// country flags
export const ADM0NAME_TO_FLAG = {
    'Comoros': 'Comoros',
    'Madagascar': 'Madagascar',
    'Mayotte': 'Mayotte',
    'Mauritius': 'Mauritius',
    'Mozambique': 'Mozambique',
    'Réunion' : 'Reunion',
    'Seychelles': 'Seychelles',
    'United Republic of Tanzania': 'Tanzania',
}

// a few layout constants
export const CYCLONE_SIZE = 0.1;  // size of cyclone icon
export const CYCLONE_LEGEND_SIZE = 20;  // size of cyclone icon size
export const MIN_ZOOM = 2;
export const MAX_ZOOM = 21;
export const MIN_ZOOM_OPACITY = 15;

// number of days after the end of a storm for the payout/simulation to be available
export const DAYS_AFTER_STORM = 30

// bbox for NASA's IMERG subset
export const BBOX = '-13.36,-41.3,99.14,3.79'

// default height and width for flood overlay
export const HEIGHT_FLOOD_OVERLAY = '25vw'
export const WIDTH_FLOOD_OVERLAY = '30vw'

// flood categories
export const FLOOD_TEXT = ['0.001m', '0.2m', '0.5m']

// flood risk parameter suffix
export const FLOOD_RISK_SUFFIX = '_flood'

// flood threshold folder
export const FLOOD_THRESHOLD_FOLDER = ''

// stochastic data
export const ECONOMIC_URLS = ['economic/adm0_thresh_0.json', 'economic/adm0_thresh_1.json'];
export const POPULATION_URLS = [
    'population/adm0_thresh_0.json',
    'population/adm0_thresh_1.json',
    'population/adm0_thresh_2.json',
    'population/adm1_thresh_0.json',
    'population/adm1_thresh_1.json',
    'population/adm1_thresh_2.json'
];

export const INDEX_TO_BAND = {
    0: 1,
    1: 5,
    2: 11,
};

// language options
export const LANGUAGES = {
    en: { nativeName: 'English' },
    fr: { nativeName: 'Français' },
    pt: { nativeName: 'Português'}
};

// font size for Flood Overlay
export const FLOOD_OVERLAY_FONT_SIZE = '60%'
